export interface Chapter {
  id: number;
  title: string;
  date: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  status: string;
  rating: number;
  views: number;
  updatedAt: string;
  chapters: Chapter[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '总裁的专属契约',
    author: '金智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20cover%20art%20in%20romance%20genre%2C%20featuring%20an%20elegant%20man%20in%20a%20suit%20and%20a%20graceful%20woman%20in%20soft%20pastel%20tones%2C%20clean%20illustration%20style%20with%20delicate%20linework%2C%20warm%20and%20romantic%20atmosphere%2C%20soft%20lighting%2C%20Korean%20manhwa%20art%20style%2C%20simple%20background%20with%20subtle%20floral%20elements&width=600&height=800&seq=comic-01&orientation=portrait',
    category: 'romance',
    description: '为了挽救家族企业，她不得不与冷酷总裁签订一份秘密契约。然而，在日复一日的相处中，这份冰冷的交易逐渐升温，演变成一场她始料未及的深情纠葛。',
    status: '连载中',
    rating: 4.8,
    views: 1280000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 命运的相遇', date: '2026-06-01' },
      { id: 2, title: '第2话 契约签订', date: '2026-06-08' },
      { id: 3, title: '第3话 同住屋檐下', date: '2026-06-15' },
      { id: 4, title: '第4话 意外的温柔', date: '2026-06-22' },
      { id: 5, title: '第5话 心中的悸动', date: '2026-07-01' },
      { id: 6, title: '第6话 危机来临', date: '2026-07-08' },
      { id: 7, title: '第7话 无法隐藏的心意', date: '2026-07-15' },
      { id: 8, title: '第8话 真相大白', date: '2026-07-22' },
      { id: 9, title: '第9话 重新选择', date: '2026-07-29' },
      { id: 10, title: '第10话 不再放手', date: '2026-08-03' },
    ],
  },
  {
    id: 2,
    title: '异世界剑圣',
    author: '朴正宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20cover%20art%2C%20a%20powerful%20warrior%20holding%20a%20glowing%20sword%20in%20a%20mystical%20realm%20with%20floating%20crystals%20and%20ancient%20ruins%2C%20epic%20atmosphere%2C%20vivid%20colors%20with%20magical%20effects%2C%20detailed%20armor%20design%2C%20Korean%20webtoon%20illustration%20style%2C%20dynamic%20composition%2C%20celestial%20background&width=600&height=800&seq=comic-02&orientation=portrait',
    category: 'fantasy',
    description: '普通高中生李浩在一次意外中穿越到剑与魔法的世界。凭借着现代人的知识与不屈的意志，他从一名籍籍无名的冒险者一步步成长为传说中的异世界剑圣。',
    status: '连载中',
    rating: 4.9,
    views: 2560000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 异世界降临', date: '2026-05-15' },
      { id: 2, title: '第2话 第一次战斗', date: '2026-05-22' },
      { id: 3, title: '第3话 剑术修行', date: '2026-05-29' },
      { id: 4, title: '第4话 公会试炼', date: '2026-06-05' },
      { id: 5, title: '第5话 迷宫探索', date: '2026-06-12' },
      { id: 6, title: '第6话 龙之巢穴', date: '2026-06-19' },
      { id: 7, title: '第7话 觉醒之力', date: '2026-06-26' },
      { id: 8, title: '第8话 王国危机', date: '2026-07-03' },
      { id: 9, title: '第9话 决战前夕', date: '2026-07-10' },
      { id: 10, title: '第10话 剑圣之名', date: '2026-07-17' },
      { id: 11, title: '第11话 新世界', date: '2026-07-24' },
      { id: 12, title: '第12话 暗流涌动', date: '2026-08-04' },
    ],
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '崔敏浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20mysterious%20Korean%20webtoon%20thriller%20cover%2C%20a%20detective%20in%20a%20trench%20coat%20standing%20under%20a%20streetlamp%20in%20a%20rainy%20alley%20at%20night%2C%20noir%20atmosphere%2C%20dramatic%20lighting%20with%20long%20shadows%2C%20Korean%20manhwa%20art%20style%2C%20dark%20blue%20and%20gray%20color%20palette%2C%20film%20noir%20aesthetic&width=600&height=800&seq=comic-03&orientation=portrait',
    category: 'thriller',
    description: '首尔深夜接连发生离奇失踪案，刑警姜道贤在调查过程中发现，所有线索都指向了一个神秘的暗夜组织。真相远比想象中更加可怕。',
    status: '连载中',
    rating: 4.7,
    views: 1890000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 深夜来电', date: '2026-06-10' },
      { id: 2, title: '第2话 第一个失踪者', date: '2026-06-17' },
      { id: 3, title: '第3话 目击证人', date: '2026-06-24' },
      { id: 4, title: '第4话 暗号密码', date: '2026-07-01' },
      { id: 5, title: '第5话 追踪', date: '2026-07-08' },
      { id: 6, title: '第6话 废弃工厂', date: '2026-07-15' },
      { id: 7, title: '第7话 真相碎片', date: '2026-07-22' },
      { id: 8, title: '第8话 组织浮现', date: '2026-08-02' },
    ],
  },
  {
    id: 4,
    title: '大小姐的逆袭',
    author: '李恩秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Korean%20romance%20comedy%20webtoon%20cover%2C%20a%20confident%20young%20woman%20in%20a%20stylish%20modern%20outfit%20with%20a%20mischievous%20smile%2C%20bright%20and%20cheerful%20color%20palette%2C%20fashionable%20urban%20background%2C%20Korean%20manhwa%20illustration%20style%20with%20clean%20lines%2C%20playful%20and%20energetic%20atmosphere&width=600&height=800&seq=comic-04&orientation=portrait',
    category: 'romance',
    description: '被未婚夫背叛、被家族抛弃的大小姐韩素希一夜之间失去一切。但她没有倒下，而是用自己的方式重新爬起来，让所有看轻她的人都刮目相看。',
    status: '连载中',
    rating: 4.6,
    views: 1650000,
    updatedAt: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 背叛之日', date: '2026-06-20' },
      { id: 2, title: '第2话 一无所有', date: '2026-06-27' },
      { id: 3, title: '第3话 重新开始', date: '2026-07-04' },
      { id: 4, title: '第4话 打工生涯', date: '2026-07-11' },
      { id: 5, title: '第5话 才华被发现', date: '2026-07-18' },
      { id: 6, title: '第6话 崭露头角', date: '2026-07-25' },
      { id: 7, title: '第7话 前未婚夫的后悔', date: '2026-08-01' },
    ],
  },
  {
    id: 5,
    title: '格斗至尊',
    author: '郑允浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20action%20manhwa%20cover%2C%20a%20muscular%20fighter%20in%20a%20dynamic%20fighting%20stance%20surrounded%20by%20energy%20effects%2C%20intense%20expression%2C%20martial%20arts%20theme%2C%20bold%20red%20and%20black%20color%20scheme%2C%20Korean%20webtoon%20art%20style%2C%20explosive%20action%20composition%2C%20dramatic%20lighting%20from%20behind&width=600&height=800&seq=comic-05&orientation=portrait',
    category: 'action',
    description: '地下格斗界的传奇人物金泰成，为了寻找失踪的妹妹而重返擂台。每一场战斗都是生死对决，而幕后黑手的真面目正一步步浮出水面。',
    status: '已完结',
    rating: 4.5,
    views: 3200000,
    updatedAt: '2026-07-15',
    chapters: [
      { id: 1, title: '第1话 地下擂台', date: '2025-12-01' },
      { id: 2, title: '第2话 不败神话', date: '2025-12-08' },
      { id: 3, title: '第3话 挑战者', date: '2025-12-15' },
    ],
  },
  {
    id: 6,
    title: '办公室罗曼史',
    author: '尹智雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20office%20romance%20webtoon%20cover%2C%20two%20attractive%20office%20workers%20sharing%20a%20coffee%20break%20moment%20with%20subtle%20romantic%20tension%2C%20modern%20office%20setting%20with%20warm%20lighting%2C%20soft%20color%20palette%2C%20Korean%20manhwa%20art%20style%2C%20elegant%20and%20refined%20illustration&width=600&height=800&seq=comic-06&orientation=portrait',
    category: 'romance',
    description: '广告公司新人林多海第一天上班就遇到了苛刻的上司宋组长。两人从针锋相对的同事关系，慢慢发现了对方不为人知的一面。办公室里的心动，悄然绽放。',
    status: '连载中',
    rating: 4.7,
    views: 980000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 入职第一天', date: '2026-07-01' },
      { id: 2, title: '第2话 严苛的上司', date: '2026-07-08' },
      { id: 3, title: '第3话 加班夜', date: '2026-07-15' },
      { id: 4, title: '第4话 出差偶遇', date: '2026-07-22' },
      { id: 5, title: '第5话 心跳加速', date: '2026-08-03' },
    ],
  },
  {
    id: 7,
    title: '魔王学院',
    author: '金道勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20webtoon%20cover%2C%20a%20mysterious%20academy%20building%20with%20gothic%20architecture%20under%20a%20purple%20night%20sky%2C%20students%20in%20dark%20uniforms%20with%20magical%20auras%2C%20mystical%20and%20enchanting%20atmosphere%2C%20Korean%20manhwa%20art%20style%2C%20dramatic%20lighting%2C%20spell%20effects&width=600&height=800&seq=comic-07&orientation=portrait',
    category: 'fantasy',
    description: '被认定为「无魔力者」的少年韩志浩，阴差阳错进入了专为魔王候选者开办的学院。在这个弱肉强食的地方，他发现了自己体内沉睡的惊人力量。',
    status: '连载中',
    rating: 4.8,
    views: 2100000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 入学通知', date: '2026-05-20' },
      { id: 2, title: '第2话 最差班级', date: '2026-05-27' },
      { id: 3, title: '第3话 觉醒试炼', date: '2026-06-03' },
      { id: 4, title: '第4话 隐藏的才能', date: '2026-06-10' },
      { id: 5, title: '第5话 学院排名战', date: '2026-06-17' },
      { id: 6, title: '第6话 黑魔法对决', date: '2026-06-24' },
      { id: 7, title: '第7话 禁书区', date: '2026-07-01' },
      { id: 8, title: '第8话 魔王的遗产', date: '2026-07-08' },
      { id: 9, title: '第9话 背叛者', date: '2026-07-15' },
      { id: 10, title: '第10话 真魔王降临', date: '2026-07-22' },
      { id: 11, title: '第11话 最终试炼', date: '2026-08-04' },
    ],
  },
  {
    id: 8,
    title: '便利店夜话',
    author: '韩智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20slice-of-life%20Korean%20webtoon%20cover%2C%20a%20cozy%20convenience%20store%20at%20night%20with%20warm%20interior%20lighting%2C%20a%20friendly%20clerk%20behind%20the%20counter%2C%20soft%20and%20heartwarming%20atmosphere%2C%20Korean%20manhwa%20illustration%20style%2C%20gentle%20colors%2C%20nostalgic%20vibe&width=600&height=800&seq=comic-08&orientation=portrait',
    category: 'comedy',
    description: '深夜便利店里，形形色色的顾客来来往往。兼职生朴美英见证了无数温暖又搞笑的小故事，从失恋的上班族到深夜觅食的大学生，每一个夜晚都有新故事。',
    status: '连载中',
    rating: 4.4,
    views: 760000,
    updatedAt: '2026-07-30',
    chapters: [
      { id: 1, title: '第1话 深夜兼职', date: '2026-06-05' },
      { id: 2, title: '第2话 第一位怪客', date: '2026-06-12' },
      { id: 3, title: '第3话 三角饭团事件', date: '2026-06-19' },
      { id: 4, title: '第4话 雨夜的客人', date: '2026-06-26' },
      { id: 5, title: '第5话 神秘常客', date: '2026-07-03' },
      { id: 6, title: '第6话 便利店情缘', date: '2026-07-10' },
      { id: 7, title: '第7话 停电之夜', date: '2026-07-17' },
      { id: 8, title: '第8话 告别与相遇', date: '2026-07-30' },
    ],
  },
  {
    id: 9,
    title: '重生之医道至尊',
    author: '孙泰英',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20drama%20cover%2C%20a%20brilliant%20doctor%20in%20a%20white%20coat%20with%20a%20determined%20expression%2C%20medical%20theme%20with%20subtle%20golden%20glow%2C%20hospital%20background%20in%20soft%20focus%2C%20Korean%20manhwa%20art%20style%2C%20professional%20and%20sophisticated%20aesthetic%2C%20warm%20and%20hopeful%20atmosphere&width=600&height=800&seq=comic-09&orientation=portrait',
    category: 'drama',
    description: '天才医生姜镇宇因为一场医疗事故含冤而死，却意外重生回到了十年前。带着前世的记忆和医术，他决心改写命运，弥补所有的遗憾。',
    status: '连载中',
    rating: 4.9,
    views: 3450000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 含冤而死', date: '2026-04-01' },
      { id: 2, title: '第2话 回到十年前', date: '2026-04-08' },
      { id: 3, title: '第3话 医大入学', date: '2026-04-15' },
      { id: 4, title: '第4话 初显医术', date: '2026-04-22' },
      { id: 5, title: '第5话 疑难杂症', date: '2026-04-29' },
      { id: 6, title: '第6话 恩师', date: '2026-05-06' },
      { id: 7, title: '第7话 手术台上的奇迹', date: '2026-05-13' },
      { id: 8, title: '第8话 暗中势力', date: '2026-05-20' },
      { id: 9, title: '第9话 前世仇人', date: '2026-05-27' },
      { id: 10, title: '第10话 命运的岔路', date: '2026-06-03' },
      { id: 11, title: '第11话 新的突破', date: '2026-06-10' },
      { id: 12, title: '第12话 医者仁心', date: '2026-06-17' },
      { id: 13, title: '第13话 暗潮涌动', date: '2026-06-24' },
      { id: 14, title: '第14话 对峙', date: '2026-07-01' },
      { id: 15, title: '第15话 曙光', date: '2026-08-04' },
    ],
  },
  {
    id: 10,
    title: '武林高手在校园',
    author: '张赫宰',
    cover: 'https://readdy.ai/api/search-image?query=A%20fun%20Korean%20action%20comedy%20webtoon%20cover%2C%20a%20high%20school%20student%20in%20uniform%20casually%20performing%20an%20impossible%20martial%20arts%20move%2C%20classmates%20looking%20shocked%20in%20the%20background%2C%20bright%20and%20energetic%20color%20palette%2C%20Korean%20manhwa%20art%20style%2C%20dynamic%20action%20pose%2C%20school%20setting&width=600&height=800&seq=comic-10&orientation=portrait',
    category: 'action',
    description: '隐退的武林至尊李风云过腻了深山修炼的日子，决定下山体验一下普通高中生活。可没想到，校园里竟然也藏着各路高手。',
    status: '连载中',
    rating: 4.6,
    views: 1560000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 下山入学', date: '2026-06-15' },
      { id: 2, title: '第2话 校园老大', date: '2026-06-22' },
      { id: 3, title: '第3话 体育课的意外', date: '2026-06-29' },
      { id: 4, title: '第4话 隐藏的高手同学', date: '2026-07-06' },
      { id: 5, title: '第5话 校际武术大赛', date: '2026-07-13' },
      { id: 6, title: '第6话 神秘转校生', date: '2026-07-20' },
      { id: 7, title: '第7话 暗黑武道', date: '2026-08-02' },
    ],
  },
  {
    id: 11,
    title: '谎言游戏',
    author: '赵贤洙',
    cover: 'https://readdy.ai/api/search-image?query=A%20psychological%20thriller%20Korean%20webtoon%20cover%2C%20a%20chessboard%20with%20elegant%20pieces%20casting%20long%20shadows%2C%20a%20mysterious%20figure%20silhouette%20in%20the%20background%2C%20dark%20sophisticated%20aesthetic%2C%20Korean%20manhwa%20art%20style%2C%20suspenseful%20atmosphere%2C%20rich%20deep%20colors&width=600&height=800&seq=comic-11&orientation=portrait',
    category: 'thriller',
    description: '十位玩家被邀请参加一场神秘的直播游戏，每个人都必须说谎才能活下去。一旦有人说了真话，就会被淘汰——而淘汰意味着真正的死亡。',
    status: '连载中',
    rating: 4.7,
    views: 1890000,
    updatedAt: '2026-07-31',
    chapters: [
      { id: 1, title: '第1话 邀请函', date: '2026-07-01' },
      { id: 2, title: '第2话 游戏规则', date: '2026-07-08' },
      { id: 3, title: '第3话 第一个淘汰者', date: '2026-07-15' },
      { id: 4, title: '第4话 联盟与背叛', date: '2026-07-22' },
      { id: 5, title: '第5话 幕后操纵者', date: '2026-07-31' },
    ],
  },
  {
    id: 12,
    title: '猫的报恩店',
    author: '吴秀晶',
    cover: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Korean%20fantasy%20webtoon%20cover%2C%20a%20small%20magical%20shop%20filled%20with%20curious%20items%20and%20cats%2C%20a%20kind-looking%20shopkeeper%2C%20warm%20golden%20lighting%2C%20Korean%20manhwa%20art%20style%2C%20cozy%20and%20enchanting%20atmosphere%2C%20detailed%20shop%20interior%2C%20magical%20sparkles&width=600&height=800&seq=comic-12&orientation=portrait',
    category: 'fantasy',
    description: '在小巷深处有一家神秘的店铺，据说只要帮助一只猫，就会得到意想不到的回报。少女尹彩琳偶然走进了这家店，发现了一个充满魔法与温暖的世界。',
    status: '已完结',
    rating: 4.5,
    views: 890000,
    updatedAt: '2026-06-30',
    chapters: [
      { id: 1, title: '第1话 巷子里的店', date: '2026-03-01' },
      { id: 2, title: '第2话 第一只猫', date: '2026-03-08' },
      { id: 3, title: '第3话 报恩的礼物', date: '2026-03-15' },
    ],
  },
  {
    id: 13,
    title: '我的室友不是人',
    author: '南智贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20supernatural%20comedy%20Korean%20webtoon%20cover%2C%20an%20ordinary%20apartment%20with%20a%20ghost%20floating%20casually%20on%20the%20sofa%2C%20a%20surprised%20human%20roommate%2C%20funny%20and%20light-hearted%20atmosphere%2C%20Korean%20manhwa%20art%20style%2C%20bright%20interior%20lighting%2C%20playful%20supernatural%20elements&width=600&height=800&seq=comic-13&orientation=portrait',
    category: 'comedy',
    description: '租房预算有限的大学生金道英找到了一个超级便宜的房子，搬进去才发现——室友是一个千年鬼魂！从此鸡飞狗跳的同居生活开始了。',
    status: '连载中',
    rating: 4.3,
    views: 670000,
    updatedAt: '2026-07-28',
    chapters: [
      { id: 1, title: '第1话 便宜没好房', date: '2026-06-01' },
      { id: 2, title: '第2话 室友现身', date: '2026-06-08' },
      { id: 3, title: '第3话 鬼室友的日常', date: '2026-06-15' },
      { id: 4, title: '第4话 驱鬼师来了', date: '2026-06-22' },
      { id: 5, title: '第5话 帮助鬼魂', date: '2026-06-29' },
      { id: 6, title: '第6话 未了的心愿', date: '2026-07-06' },
      { id: 7, title: '第7话 意外的温暖', date: '2026-07-13' },
      { id: 8, title: '第8话 新的房客', date: '2026-07-28' },
    ],
  },
  {
    id: 14,
    title: '星之继承者',
    author: '刘承俊',
    cover: 'https://readdy.ai/api/search-image?query=A%20grand%20sci-fi%20fantasy%20Korean%20webtoon%20cover%2C%20a%20young%20hero%20reaching%20toward%20a%20brilliant%20star%20in%20a%20vast%20cosmos%2C%20starships%20in%20the%20distance%2C%20epic%20space%20opera%20aesthetic%2C%20Korean%20manhwa%20art%20style%2C%20cosmic%20colors%2C%20inspirational%20and%20grandiose%20composition&width=600&height=800&seq=comic-14&orientation=portrait',
    category: 'drama',
    description: '人类终于踏入了星际时代，少年维恩却发现自己是被选中继承一颗神秘星球力量的人。银河帝国的阴谋、外星种族的战争，他将如何守护这份遗产？',
    status: '连载中',
    rating: 4.8,
    views: 2340000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 星之印记', date: '2026-05-01' },
      { id: 2, title: '第2话 帝国学院', date: '2026-05-08' },
      { id: 3, title: '第3话 模拟战', date: '2026-05-15' },
      { id: 4, title: '第4话 隐藏的能力', date: '2026-05-22' },
      { id: 5, title: '第5话 边境冲突', date: '2026-05-29' },
      { id: 6, title: '第6话 外星盟友', date: '2026-06-05' },
      { id: 7, title: '第7话 星际航行', date: '2026-06-12' },
      { id: 8, title: '第8话 古老遗迹', date: '2026-06-19' },
      { id: 9, title: '第9话 传承试炼', date: '2026-06-26' },
      { id: 10, title: '第10话 帝国阴谋', date: '2026-07-03' },
      { id: 11, title: '第11话 叛军', date: '2026-07-10' },
      { id: 12, title: '第12话 星辰之力的觉醒', date: '2026-07-17' },
      { id: 13, title: '第13话 决断的时刻', date: '2026-07-24' },
      { id: 14, title: '第14话 继承者之战', date: '2026-08-03' },
    ],
  },
  {
    id: 15,
    title: '大厨的浪漫食谱',
    author: '姜贤宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20delicious%20romance%20Korean%20webtoon%20cover%2C%20a%20handsome%20chef%20in%20a%20professional%20kitchen%20presenting%20a%20beautiful%20dish%2C%20warm%20restaurant%20atmosphere%2C%20appetizing%20food%20illustration%2C%20Korean%20manhwa%20art%20style%2C%20romantic%20and%20cozy%20vibe%2C%20soft%20lighting%2C%20culinary%20theme&width=600&height=800&seq=comic-15&orientation=portrait',
    category: 'romance',
    description: '米其林三星主厨车贤宇失去了味觉，就在他准备放弃料理时，遇到了拥有绝对味觉的美食博主韩多温。两人在美食与爱的旅程中，重新找到了生活的滋味。',
    status: '连载中',
    rating: 4.7,
    views: 1120000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 失去味觉的主厨', date: '2026-06-10' },
      { id: 2, title: '第2话 美食博主的挑战', date: '2026-06-17' },
      { id: 3, title: '第3话 厨房里的碰撞', date: '2026-06-24' },
      { id: 4, title: '第4话 味觉的秘密', date: '2026-07-01' },
      { id: 5, title: '第5话 一起研发新菜', date: '2026-07-08' },
      { id: 6, title: '第6话 心动食谱', date: '2026-07-15' },
      { id: 7, title: '第7话 料理大赛', date: '2026-07-22' },
      { id: 8, title: '第8话 重返巅峰', date: '2026-08-04' },
    ],
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.category === slug);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getLatestComics(limit: number = 6): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getPopularComics(limit: number = 6): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}